<template>
  <div
    @click="removeLists"
  >
    <div
      v-show="!close "
    >
      <div style="display: flex; justify-content: space-between; width: 100%; border-bottom: 1px solid lightgray;">
        <p style="font-size: 32px; font-weight: bold;">
          {{ $t("Filiales") }}
        </p>
        <div style="display: flex; padding-right: 15px; margin-top: 5px">
          <!-- <div class="search-toggle">
          <p>{{ $t("SearchBy") }}</p>
          <div>
            <p>
              {{ $t("FilialeName") }}
            </p>
          </div>
        </div> -->
          <div>
            <button
              style="border: 0; width: 48px; height: 36px; background: transparent linear-gradient(53deg, #0071AE 0%, #55B94A 100%) 0% 0% no-repeat padding-box; border-radius: 5px; margin-right: 10px;"
              @click="downloadPDF"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="20"
                height="20"
                fill="white"
                class="bi bi-file-earmark-pdf"
                viewBox="0 0 16 16"
              >
                <path d="M14 14V4.5L9.5 0H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2zM9.5 3A1.5 1.5 0 0 0 11 4.5h2V14a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1h5.5v2z" />
                <path d="M4.603 14.087a.81.81 0 0 1-.438-.42c-.195-.388-.13-.776.08-1.102.198-.307.526-.568.897-.787a7.68 7.68 0 0 1 1.482-.645 19.697 19.697 0 0 0 1.062-2.227 7.269 7.269 0 0 1-.43-1.295c-.086-.4-.119-.796-.046-1.136.075-.354.274-.672.65-.823.192-.077.4-.12.602-.077a.7.7 0 0 1 .477.365c.088.164.12.356.127.538.007.188-.012.396-.047.614-.084.51-.27 1.134-.52 1.794a10.954 10.954 0 0 0 .98 1.686 5.753 5.753 0 0 1 1.334.05c.364.066.734.195.96.465.12.144.193.32.2.518.007.192-.047.382-.138.563a1.04 1.04 0 0 1-.354.416.856.856 0 0 1-.51.138c-.331-.014-.654-.196-.933-.417a5.712 5.712 0 0 1-.911-.95 11.651 11.651 0 0 0-1.997.406 11.307 11.307 0 0 1-1.02 1.51c-.292.35-.609.656-.927.787a.793.793 0 0 1-.58.029zm1.379-1.901c-.166.076-.32.156-.459.238-.328.194-.541.383-.647.547-.094.145-.096.25-.04.361.01.022.02.036.026.044a.266.266 0 0 0 .035-.012c.137-.056.355-.235.635-.572a8.18 8.18 0 0 0 .45-.606zm1.64-1.33a12.71 12.71 0 0 1 1.01-.193 11.744 11.744 0 0 1-.51-.858 20.801 20.801 0 0 1-.5 1.05zm2.446.45c.15.163.296.3.435.41.24.19.407.253.498.256a.107.107 0 0 0 .07-.015.307.307 0 0 0 .094-.125.436.436 0 0 0 .059-.2.095.095 0 0 0-.026-.063c-.052-.062-.2-.152-.518-.209a3.876 3.876 0 0 0-.612-.053zM8.078 7.8a6.7 6.7 0 0 0 .2-.828c.031-.188.043-.343.038-.465a.613.613 0 0 0-.032-.198.517.517 0 0 0-.145.04c-.087.035-.158.106-.196.283-.04.192-.03.469.046.822.024.111.054.227.09.346z" />
              </svg>
            </button>
          </div>
          <div>
            <button
              style="border: 0; width: 48px; height: 37px; background: transparent linear-gradient(53deg, #0071AE 0%, #55B94A 100%) 0% 0% no-repeat padding-box; border-radius: 5px;"
              @click="downloadEXCEL"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="16"
                height="16"
                fill="white"
                class="bi bi-file-earmark-spreadsheet"
                viewBox="0 0 16 16"
              >
                <path d="M14 14V4.5L9.5 0H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2zM9.5 3A1.5 1.5 0 0 0 11 4.5h2V9H3V2a1 1 0 0 1 1-1h5.5v2zM3 12v-2h2v2H3zm0 1h2v2H4a1 1 0 0 1-1-1v-1zm3 2v-2h3v2H6zm4 0v-2h3v1a1 1 0 0 1-1 1h-2zm3-3h-3v-2h3v2zm-7 0v-2h3v2H6z" />
              </svg>
            </button>
          </div>
        </div>
      </div>
      <div style="display: flex; flex-direction: row; align-items: center;">
        <div>
          <div class="black">
            <b-icon-search
              v-if="searchFiliale == ''"
              class="search1"
              style="position: absolute; left: 5px; top: 10px"
            />
            <b-icon-x-circle
              v-else-if="searchFiliale != '' && !noSearch"
              class="search1"
              style="position: absolute; margin-top: -6px; right: 10px; top: 17px; cursor: pointer"
              @click="searchFiliale = ''"
            />
            <input
              v-model="searchFiliale"
              type="text"
              autocomplete="off"
              name="search-box"
              :style="getFilterStoreName.length > 0 && noSearch? 'border-radius: 8px 8px 8px 8px': 'border-radius: 8px 8px 8px 8px; padding-left: 50px;'"
              @keyup="inputChanged"
              @keydown.down="onArrowDown"
              @keydown.up="onArrowUp"
            >
          </div>
          <div
            v-if="getFilterStoreName.length > 0 && noSearch"
            ref="scrollContainer"
            class="dropdrop"
            :style="getFilterStoreName.length > 7 ? 'height: 210px' : 'height: auto'"
          >
            <div
              v-for="(result, index) in getFilterStoreName"
              :key="result"
              ref="options"
              style="cursor: pointer"
              class="search-item"
              :class="{ 'is-active': index === arrowCounter }"
              @click="
                searchByOn(result);
                oSearch = false;"
            >
              <p style="margin: 0">
                {{ result }}
              </p>
            </div>
          </div>
        </div>
        <div style="width:15%">
          <vue-select
            v-model="platform"
            :options="platforms"
            label="name"
            :reduce="(e) => e.value"
            :placeholder="$t('Platform')"
            style="width:100%"
          />
        </div>
        <button
          v-if="getLoggedInUser.role != 'Manager'"
          v-b-modal.add-filiale
          class="button"
          style="border-radius: 6px; width:240px; margin-top: 20px; margin-left: 10px; margin-right: 10px;"
          @click="fetchCantons"
        >
          <b-icon-plus />
          {{ $t("AddNewFiliale") }}
        </button>
      <!-- <button
        class="button"
        style="border-radius: 6px; width:240px; margin-top: 25px; visibility: hidden;"
      >
        <b-icon-plus />
        {{ $t("AddNewFiliale") }}
      </button> -->
      </div>

      <div style="width: 100%; padding-top: 16px; margin-top: -3px">
        <table
          class="team_table"
          style="width: 100% !important; box-shadow: 0px 7px 20px rgb(40 41 61 / 8%); text-align: left;"
        >
          <thead>
            <tr>
              <th style="padding: 10px; border-radius: 10px 0px 0px 0px">
                {{ $t("No.") }}
              </th>
              <th style="padding: 10px; border-radius: 0px 0px 0px 0px">
                {{ $t("Platform") }}
              </th>
              <th style="padding: 10px; border-radius: 0px 0px 0px 0px">
                {{ $t("FilialeName") }}
              </th>
              <th style="padding: 10px">
                {{ $t("GlobalNumber") }}
              </th>
              <th style="padding: 10px">
                {{ $t("EmailAddress") }}
              </th>
              <th style="padding: 10px">
                {{ $t("PhoneNumber") }}
              </th>
              <th>{{ $t("Address") }}</th>
              <th style="padding: 10px">
                {{ $t("Trucks") }}
              </th>
              <th style="padding: 10px; text-align: left;">
                {{ $t("Manager") }}

              </th>
              <th style="padding: 10px">
                {{ $t("TeamLeader") }}
              </th>
              <th style="padding: 10px">
                {{ $t("Co-TeamLeader") }}

              </th>
              <th>{{ $t("Actions") }}
              </th>
              <th style="border-radius: 0px 10px 0px 0px" />
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="(name,index) in getExtendedFiliales"
              :key="name.storeId"
              v-b-tooltip.hover.bottom
              :title="`Click for ${name.storeName} details`"
              style="border-bottom: 1px solid #dcdfe6; color: #606266; cursor: pointer;"
              :style="classNameCh === name.storeId ? 'background-color: #e8e8e8' : ''"
              @click="matProps(name.storeId); "
            >
              <td style="padding: 10px">
                {{ getTotalItemsForFiliales - (pageNumber - 1) * pageSize - index }}.
              </td>
              <td style="padding: 10px">
                {{ name.platform }}
              </td>
              <td style="padding: 10px">
                {{ name.storeName }}
              </td>
              <td style="padding: 10px">
                {{ name.gln }}
              </td>
              <td style="padding: 10px">
                {{ name.email }}
              </td>
              <td style="padding: 10px">
                {{ name.phone }}
              </td>
              <td> {{ name.street }}, {{ name.door }}-{{ name.house }} / {{ name.postal }}, {{ name.city }} / {{ name.country }}</td>
              <td style="padding: 10px">
                {{ name.truckNumbers }}
              </td>
              <td style="padding: 10px;text-align: left;">
                <p
                  class="p-0 m-0 ml-50"
                >
                  {{ name.managerName }}
                </p>
                <b-button
                  v-if="name.managerName == null"
                  v-b-modal.assign-staff-manager
                  style="max-height: 35px; font-size: small;"
                  @click="matProps(name.storeId); loadManagers()"
                >
                  {{ $t("Assign") }}

                </b-button>
              </td>
              <td style="padding: 10px;">
                <p
                  class="p-0 m-0 ml-50"
                >
                  {{ name.teamLeaderName }}
                </p>
                <b-button
                  v-if="name.teamLeaderName == null"
                  v-b-modal.assign-staff
                  style="max-height: 35px; font-size: small;"
                  @click="matProps(name.storeId); teamLeader()"
                >
                  {{ $t("Assign") }}
                </b-button>
              </td>
              <td style="padding: 10px">
                <p
                  v-b-modal.edit-teamLeader-store
                  class="p-0 m-0 ml-50"
                >
                  {{ name.coTeamLeaderName }}
                </p>
                <b-button
                  v-if="name.coTeamLeaderName == null"
                  v-b-modal.assign-staff-coTeamLeader
                  style="max-height: 35px; font-size: small;"
                  @click="matProps(name.storeId); loadCoTeamLeaders()"
                >
                  {{ $t("Assign") }}

                </b-button>
              </td>
              <td
                style="padding: 10px; text-align: left; cursor: pointer"
              >
                <p
                  style="display: flex;
    justify-content: space-between; align-items: center;"
                  class="p-0 m-0 ml-50"
                >
                  <b-icon-pencil
                    v-b-toggle.edit-filiale-toggle

                    @click="editFiliale(name.storeId); loadManagers(); loadCoTeamLeaders(); teamLeader()"
                  />
                  <img
                    src="../../assets//next.png"
                    alt=""
                    style="width: 20px;"
                    @click="obj(name);
                            close = true"
                  >
                </p>
              </td>
            </tr>
          </tbody>
        </table>

      </div>
      <div>
        <b-pagination
          v-model="pageNumber"
          :total-rows="getTotalItemsForFiliales"
          :per-page="pageSize"
          first-number
          last-number
          align="right"
          prev-class="prev-item"
          next-class="next-item"
          class="mt-1 mb-0"
        >
          <template #prev-text>
            <span>{{ $t("Previous") }}</span>
          </template>
          <template #next-text>
            <span>{{ $t("Next") }}</span>
          </template>
        </b-pagination>
      </div>
    </div>
    <b-button
      v-show="close"
      type="button"
      variant="none"
      class="buttonSubmit"
      style="width: 220px"
      @click="resetView()"
    >
      <!-- <b-icon icon="skip-start" /> -->
      {{ $t("GoBack") }}
    </b-button>
    <AddFilialeModal @addFiliale="addFilialee" />
    <EditFilialeModal
      :edit-filiale="onEditFiliale"
      @edit="editStore"
    />
    <EditTeamLeaderModalStore />
    <AssignManager
      :store-id="storeId"
      @assignManager="handleAssignManager"
    />
    <AssignTeamLeader
      :store-id="storeId"
      @assignTeamLeader="handleAssignTeamLeader"
    />
    <AssignCoTeamLeader
      :store-id="storeId"
      @assignCoTeamLeader="handleAssignCoTeamLeader"
    />
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
// eslint-disable-next-line no-unused-vars
import AssignManager from '@/components/filiale/modals/AssignManager.vue';
import AssignTeamLeader from '@/components/filiale/modals/AssignTeamLeader.vue';
import AssignCoTeamLeader from '@/components/filiale/modals/AssignCoTeamLeader.vue';
import AddFilialeModal from '@/components/filiale/modals/AddFilialeModal.vue';
import EditFilialeModal from '@/components/filiale/modals/EditFilialeModal.vue';
import EditTeamLeaderModalStore from '@/components/filiale/modals/EditTeamLeaderModalStore.vue';
// import axios from 'axios'
import jsPDF from 'jspdf';
import 'jspdf-autotable';
// import XLSX from 'xlsx';
import FileSaver from 'file-saver';
import * as XLSX from 'xlsx';
import moment from 'moment'



export default {
  components: {
    AddFilialeModal,
    EditFilialeModal,
    AssignManager,
    EditTeamLeaderModalStore,
    AssignTeamLeader,
    AssignCoTeamLeader,
  },
  // eslint-disable-next-line vue/require-prop-types
  props: ['materialId', 'createOrder'],
  data() {
    return {
      platform: null,
      platforms: [
        {
          value: 'Moemax', name: 'Moemax',
        },
        {
          value: 'Pfinser', name: 'Pfinser',
        },
        {
          value: 'Conforama', name: 'Conforama',
        },
        {
          value: 'Lipo', name: 'Lipo',
        },
      ],
      id: '',
      initialId: '',
      status: true,
      classNameCh: '',
      searchTerm: '',
      pageSize: 15,
      pageNumber: 1,
      noSearch: false,
      searchFiliale: '',
      arrowCounter: 0,
      enterPressed: false,
      close: false,
      rows: [],
      materialObject: {},
      searchStore: '',
      storeId: '',
      editMat: {},
      color: {
        mainDressCategoryColorId: '',
        name: '',
      },
      onEditFiliale: {
        storeId: '',
        name: '',
        gln: '',
        phone: '',
        email: '',
        street: '',
        houseNumber: '',
        doorNumber: '',
        postalCode: '',
        city: '',
        country: '',
        canton: '',
        teamLeaderId: '',
        coTeamLeaderId: '',
      },
    };
  },

  computed: {
    ...mapGetters([
      'getFiliales',
      'getExtendedFiliales',
      'getTotalItemsForFiliales',
      'getCantons',
      'getFilterStoreName',
      'getFiliale',
      'fullNamesByRoles',
      'getLoggedInUser',
      'getLoggedInUser',
      'getExtendedFilialesPDF',
    ]),
  },
  watch: {
    // eslint-disable-next-line func-names
    materialId() {
      this.classNameCh = '';
    },
    pageNumber(value) {
      this.loadStoresByPagination({
        storeName: this.searchFiliale,
        platform: this.platform,
        pageNumber: value,
        pageSize: this.pageSize,
      });
    },
    platform(value) {
      this.loadStoresByPagination({
        storeName: this.searchFiliale,
        platform: value,
        pageNumber: this.pageNumber,
        pageSize: this.pageSize,
      });
    },
    searchFiliale(value) {
      if (value == '') {
        this.removeLists();
        this.loadStoresByPagination({
          storeName: value,
          platform: this.platform,
          pageNumber: this.pageNumber,
          pageSize: this.pageSize,
        });
      } else if (this.enterPressed) {
        // eslint-disable-next-line no-useless-return
        return;
      } else {
        this.loadFilteredStoreName(value);
        this.noSearch = true;
      }
    },
  },
  mounted() {
    this.fetch();
    this.fetchCantons();
  },
  methods: {
    ...mapActions([
      'addFiliale',
      'loadStoresByPagination',
      'changeLoadingtoTrue',
      'editFilialeById',
      'loadFilialePagination',
      'loadCountryStates',
      'loadRegularEmployeeOverview',
      'loadUpComingVacations',
      'loadStoreMainboardOverview',
      'loadFilteredStoreName',
      'freeCoTeamLeaders',
      'getFilialeById',
      'resetFilteredFiliale',
      'loadUsersFullNamesById',
      'assignTeamLeader',
      'assignCoTeamLeader',
      'loadFreeManagers',
      'assignManager',
      'freeTeamLeaders',
      'loadStoresByPaginationPDF',
    ]),


    downloadPDF() {
      // this.changeLoadingtoTrue(false);

      // axios
      //   .get('https://logisticstoredata.digitwebsite.ch/api/v1/extendedStoresByPagination?PageNumber=1&PageSize=12')
      this.loadStoresByPaginationPDF({
        storeName: this.searchFiliale,
        platform: this.platform,
        pageNumber: this.pageNumber,
        pageSize: this.pageSize,
      })
        .then(() => {
          // const data = response.data;
          // const items = data.items;

          const tableContent = this.generateTableContent(this.getExtendedFilialesPDF.items);

          const totalPages = this.getExtendedFilialesPDF.totalPages;
          const additionalPromises = [];
          for (let pageNumber = 2; pageNumber <= totalPages; pageNumber++) {
            additionalPromises.push(this.downloadPage(pageNumber));
          }

          Promise.all(additionalPromises).then((additionalTableContents) => {
            additionalTableContents.forEach((additionalTableContent) => {
              tableContent.body.push(...additionalTableContent.body);
            });

            const spimLogo = 'data:image/png;base64,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'
            const clientLogo = 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAIAAAAAqCAYAAAB7uVNDAAAAAXNSR0IArs4c6QAADT1JREFUeF7VXHvUbdUU//0OxlWiiMgzbl2VXlSU20tFLyklz3SV7kU14gqplG4lhhqJSLq9FUVi6EkPJPRESbkNvQiNuFHeyfkZv33WPt/e5+zH2vvs7yvzn+8b+6w111xzzTXfexMlIGk5AO8A8CYAqwJ4PoAnlo4HwOIfryW5cdm86XpuWjRdyHN4O1ipJYqyaU3QFZ6ZpN0AfAnA0zvg4SEkjy7F04TaDogZokjWbbl4y2lj5HeFp4YvVVvNCYBkjugkgQtKbnPBUr5npaMvBbALyX/FnN0M8WOElLhV40ZNoW46PoY/0zFmeHKDw8c5AN6WWejfAL4N4GoAdwB4pAERS0n+osH4GR4ajmjspMqeNyDv/+X0s1dX0j4AvpDZ5kkArL4fHNzwIovawU47QNHgaCYcGkNszJgYMrrCU70Wfbbq63kAlgB4Shj+EZLHxJA5PWNmZvPTQ/vjBWscDxMTIMkO34JA+jdI2vPvHCbxu7ohJo4pj+e1ut4Bpf7KAH8L4AkA/gZgNZL3573lLEu6JiGC3S2XjJ5WMDB6bg35MXhixkRwqdUQSnoPANt7w6dJHpj8V0lVVyR3hadg79OIup4/rc6ifFKZo9rBMhaArwJ4a8C1BslfVeHN0tKex+1ndrDnyVBMB+kd+9hNSLQA+MBfCuAPJJ/bnjtNlo1dJeDs6gZMB4kdmIBYbkw+bpwBFoClAJ4B4EaSG06+SDGGbngfhyVuVBGd5TPb4+yKo9PjqFgA/hNy/FeT3LwrcrvFMwn7y7RISwpjfKNJyG1J1ti0mm2nJFoAnN17EoDHpGjTxX5b8bvVpC6ozeDoyrRNQJYF4CBAswA+QPLEfACQp7C9r9L0Fk5yOpPMnYCTMzq1gW9Uww7/3DnM+BE0WLC9EJexqcHinXN6CmFbKqwBNgPQa0GbK3xOIP2e5MyU3guJbLv1KlXcghuTTonxLSZdo2C+BeAeAC+qxF1Z8cVDAL4C4HN1OYRu6e/g4DslqCk9TcdniZ1kbn7TFoAjABzaAS/sTBrPsST71fhcg9IMdex0sLMaFN0cRzdY4nY7tZYFwBHA8QDeCeCpcQgqR53vngKSj3aAKx7FJPxr6hgk4ydZMH5b6cjpWq21EyhpGQBrAHgtgL0gzMk0Bl1Actdm25xsi8Wzm0YfNSWQsQ3F0BwzJo5TlXsssu8RfZGtBSC7niRXEvcF8NnM8z1JnhG3tYpRj5FzNDHdUQg6EI6mKEbG2wScBeBUkj+IorlikCQLwefDkIcBvHjQUVQMkj4KYFsAZzQRFkluVv0UAGcuXwDArWuOSM4DcAxJZzejQNLaAN5uWgE8O+Bya9wlJJ0mLyyMBr7556+TvQuzHVOS3D29I4D1AKwTmmvvc9WV5DUjl2dTAEdGEQvcRPIAj5Xky9UTcFePPDydL8kOuWs6C0n+bBSvpJcD+Ex4foIFIA3hNiP5w9EJTQVM0mUAtgl4jiR5WIUAnAlgDwBHkPx4DBMk7QDA81YcGz+IVlzc2pXkbVX4JK0QyuBvqRhnITu0yJ+R5H7HtQC8geSFmQNYHsD3AJjRRbAYwHvJXt9CI8mm0n5TgBByFUdeV5HcKiMA8wAsYl4A7gawCoCtSV6ZYvU59vtaFsQvw+/XA5ibFYBzSO4ecwg1jHVIeWdoMPkLgGeVOYSSGgmApPmhXd378a3/PoBbg/P6MgCvDhfW2mc7kj8uolWStcZ3gg/jIW54/YkrouFQtwbw5DDXmnHb0c7mCgE4NfGJBuAeS6/jG2ntaG1jGB6aJPtRo0K4XxBwa6JfZ/ZwF0lr7FQDzIOwiL2cBigUgDAn5bfPZW2S92UFYAnZW72L1ykyB+t1Nx1Ve5nbUiMAU/pHkg/l8jD3uHAz/5E9YEkrCzibwJYA/uoyN0kf6tT9Gqhnq0bfXguRm2FtgoahqySbglMAvD49SJI+lCyejAYYmAAp6a28Nwj/PiS/mNnrrCCwGwFwEm1Fkjn6h2P7WgJiDoDtSbq1fgyCCZgnYNGICSgUAEnu+XDvh2EHkpf4n6EACFjaI59ZtFjds0xUmcT3femNAC4I8z5G8hNTOHKHGqUBQsRxe0hYnUJyfpm/LmlZALazVsHfImlasgd3MADT89/A4O+WMNgHdgWETZJNAauTtKZIoEgDSLIG/bL9EZIvHMUr6ZUArgvPtyjzuyS5QXdEAPLGOBEAYR5YbwIk2SRY9Zs3Tti9P6UtqwGsXmbXHXbM75Jsn/8Uxp5LMvuuQfYwYgVgbwGLCdiRmkPyn1V0SPLt/nm4iWuR9OZ9aI5W/hxMxsIeeXxVDluSVbcF72kATibp9rkqAVgIwNrpcpKvG6Nx0IG9RXh+G9l7oEjjFgtAHpsFQMA81vgAwSG9ITik5smrSA7f74gWgKbOYF96hIMy8zUk7emOKYFYH0CS7agZejDJT0YKoVWnI4zDSCZetvraHtTFAC2cK1XVMOr2W6IB3gXg9GC3LaitaiSxAgCg1gmUdCwARw42ieuQdOp/CHkB6HF2V/lZSb6ttol3kHTL2RiMCkAR04NKN/EuWHkDUW8bSbLNPiHb5yDJ5e73ATiLpJnXGkoEYN2geYy3JrIpF7FoExAEwD5AKmmShj5A2NwV4a9f0fvm6IajNcA4p8o3kIQc0t+DzbmBpG1frQCUjLEttE0UyeiqpaRNADisdZ+DnTqbgFQrfJBkGgs3E4KQBpb6ZWGgQy87oQYzfxGA67Nqt25Bqb8EYJQTWBAG3hVyGo4sHIXYr8uZr3INwN7sjqIAx9i2tYaLSDopMgVBdhINIOwBlt8WSU72ONy7n+TKdcxLf5e0WgjvfDlmOTkkyTbQt3R3kg6xhiBpbkhrVy1xHkn7BIVOYHjuENN5Aa+Tgr1+v2NprZD4I1UQbwI0D+BoHsAh+EtCSGt+eb0Ny/ymbBTwxx65Uh1xpb9nFIKkneyBh7FT7xqMTJb6ZwLMJ4JGFIsk23Hf3DtJ+jsFUeCQ0L0KYfAKJB/KdECPqUNJH/Z7ETXIh/PK8gAZAdze/oedrgxOF8j82l2F9iEGGiAuDMxrgGRuKgDpsseRvQPGLnZaJslkAm8nuWYUd5NBlTbMyQpXFw1OyDg7mINgJmqjAEmvAHATgIdJOstW/c5KWEWS07CO9x8laWfUt9ZvOdshXUDSGbkh9KW5HBS2iiDNUu5I8qKAq9AEjE6WtCWg/QE6O5oml44meUgZr/MaoHdpUek8zQNUmAC/7ueoxRrQiazCcDfrA5xG8t3xAlA8UpJz6pZCn7HDNXvbfuVsDIqjgLF49zlBnXn+8iSd5auFjBa6m6RVogXgawD88YujSEb1QISkUPqqnF+bSzJzdRqgQBBcvzg3RDP+eRWS9xaJc7UJGPAnQgC2grA7iD0BOPPncPh3o3SlAmAbtTFJ28hxqIuJMjMk2fGyA2YodT4CE2s1QBhnVW6VvgdJJ1pqQdJpQLL5s0km2kiSwyGHRbeQzNroUnySdgZg79lZu+XS0K6pAIT1nVz6jS+F08UkHTIWXYyWJiDZY+oEumbgVLi1pzW7//qMc4UyC4Dt3pkxzkkd1yX5UzAHhXFWPWtWtYk1yAM4ueIky3UknUodQknoaAb7prrBZZtU/YWMmMMkwyYkf5QiymYzRyp7zmg6m2geOc5PoDgM7M8GaCfwQZK3lByuHUSnmEtzGvFOYF0eoHel1LffZHNl83Mie9w3G+p31Q/gD0r5Nu+S2bSraEflmTCm3mM1gNO6Pw245pO9U6qiFUlWtQ6DXBF07sBp3/TgXNxxI+ytgNYne6VfPclEIJ67OUn7EBUCkJS3nai6h6RN4RhIugHQBgD3J+k8RdGYFhogmIa+7gbz1UBJ1oTWiIbdSA6rj60FoC8tw0FBZTsAe4e6fLoZe+0uOFRmwmI1QLhxaRLHnrSdsctCSJ6TBUn2sD8QnB+rvDT3nh5cNk1sOnfOpUbDREmOw68KyaxLSdqrH0JJIshq94oBQRwrr4fKn8Myk57TQCO4WwjAUDDLikHulXhzMGUbDMJZJsUg58etYi0loSewug24SGozz24E4EKHE0GV0FAArGWuBeCyryt39gVOBnCzncMQd/vV9vT1tioV+yE3jgTi7LA6WeMCkhtA/H6kQ09XCV08seO0Hpmkj4c+W4kAmJdOtfqTej7EnUj6r02GTYN9ifWtmUh6HwMYD30nEgDZwRzpBwgZ1ZshrAom5nFdVyMtAO4miWrGqDtPdxYBOHDYBZTGmiW9aVMCUCpwG2VvsCQftG9t3XcH3ZnsuL4UJO0FaDFQmV1004QPceqDGQFjRT+AD/hKCMuHKqKZ7WjImseZTGuw15SVyIOwTCQARQ0hAW/qDNofOJ/kbhYA16/HSpflnBv7KpxDDHuzi9MsWd3NT38f6RsompYTgLAJ1/PdGOIki0PELFhDHE7SxaNakGSGuFBkJy9rDn3rfTFOz/oPWYRVUYCriK7Tc/ChTTfPGnzwF4fi1IiDOOYbTYsABP7ZXKc5kP3+By7PYT+7xhKDAAAAAElFTkSuQmCC'
            const digITLogo = 'data:image/png;base64,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'

            const pdfDocument = this.generatePDF(tableContent, clientLogo, spimLogo, digITLogo, 800);
            pdfDocument.save(`Filiales-${moment().format('DD/MM/YYYY - hh-mm-s')}.pdf`);
          });
          // this.changeLoadingtoTrue(true);
        })
        .catch((error) => {
          console.error('Error downloading the data:', error);
          // this.changeLoadingtoTrue(false);
        });
    },
    resetView() {
      this.close = false;
      this.getFiliales = [];
      this.$emit('show-other-component');

      // reset any other relevant data properties
    },
    downloadPage(pageNumber) {
      // axios
      //   .get(
      //     `https://logisticstoredata.digitwebsite.ch/api/v1/extendedStoresByPagination?PageNumber=${pageNumber}&PageSize=12`,
      //   )
      // this.changeLoadingtoTrue(false);


      return this.loadStoresByPaginationPDF({
        storeName: this.searchFiliale,
        platform: this.platform,
        pageNumber,
        pageSize: this.pageSize,
      })

        .then(() => {
          // const data = response.data;
          // const items = data.items;
          // this.changeLoadingtoTrue(true);

          return this.generateTableContent(this.getExtendedFilialesPDF.items);
        })
        .catch((error) => {
          console.error('Error downloading the data:', error);
          // this.changeLoadingtoTrue(false);
        });
    },
    generateTableContent(items) {
      // const headers = [`${this.$t('FilialeName')}`, 'GLN', 'Email', 'Phone', 'Street', 'City', 'Country', 'Trucks', 'Manager', 'TeamLeader', 'Co-TeamLeader'];

      const headers = [`${this.$t('Platform')}`, `${this.$t('FilialeName')}`, `${this.$t('GlobalNumber')}`,
        `${this.$t('EmailAddress')}`, `${this.$t('PhoneNumber')}`,
        `${this.$t('AddNew42')}`, `${this.$t('AddNew43')}`,
        `${this.$t('Trucks')}`, `${this.$t('Manager')}`, `${this.$t('TeamLeader')}`, `${this.$t('Co-TeamLeader')}`];
      const body = items.map((item) => {
        return [
          item.platform,
          item.storeName,
          item.gln,
          item.email,
          item.phone,
          item.city,
          item.country,
          item.truckNumbers,
          item.managerName,
          item.teamLeaderName,
          item.coTeamLeaderName,
        ]
      });

      return { headers, body };
    },
    // generatePDF(tableContent) {
    //   const { headers, body } = tableContent;

    //   // eslint-disable-next-line new-cap
    //   const doc = new jsPDF();
    //   doc.autoTable({
    //     head: [headers],
    //     body,
    //   });

    //   return doc;
    // },
    generatePDF(tableContent, clientLogo, spimLogo, digITLogo, customWidth) {
      const { headers, body } = tableContent;

      // eslint-disable-next-line new-cap
      const doc = new jsPDF({
        orientation: 'landscape', // Set the orientation to landscape if you want a wider document
        unit: 'pt', // Use points as the unit of measurement
      });

      // Set custom width after creating the doc instance
      doc.setProperties({
        format: [customWidth, doc.internal.pageSize.getHeight()], // Set custom width
      });

      // doc.setProperties({
      //   format: [customWidth, doc.internal.pageSize.getHeight()], // Set custom width
      // });

      // Add the logo to the top left corner of the first page
      const blueBackgroundX = 0;
      const blueBackgroundWidth = doc.internal.pageSize.getWidth();
      const blueBackgroundHeight = 60; // Adjust the height as needed
      doc.setFillColor(0, 113, 174); // Blue color
      doc.rect(blueBackgroundX, 0, blueBackgroundWidth, blueBackgroundHeight, 'F');

      const iconWidthClient = 80; // Adjust the width of the icon as needed
      const iconHeightClient = 30; // Adjust the height of the icon as needed
      const iconYClient = 10; // Adjust the vertical position of the icon (top)
      const iconXClient = 40; // Adjust the horizontal position of the icon (left)

      const iconWidthSpim = 80; // Adjust the width of the icon as needed
      const iconHeightSpim = 30; // Adjust the height of the icon as needed
      const iconYSpim = 10; // Adjust the vertical position of the icon (top)
      const iconXSpim = doc.internal.pageSize.getWidth() - 120; // Adjust the horizontal position of the icon (left)

      // Draw a blue background rectangle that spans the entire width of the paper

      // Add the logo image on top of the blue background on the top left
      doc.addImage(clientLogo, 'SVG', iconXClient, iconYClient, iconWidthClient, iconHeightClient);

      // const iconX = 15; // Adjust the horizontal position of the icon (left)
      doc.addImage(spimLogo, 'SVG', iconXSpim, iconYSpim, iconWidthSpim, iconHeightSpim);

      const staticContent = () => {
        // Draw blue background for the footer
        const blueBackgroundFooterX = 0;
        const blueBackgroundFooterY = doc.internal.pageSize.getHeight() - 35;
        const blueBackgroundFooterWidth = doc.internal.pageSize.getWidth();
        const blueBackgroundFooterHeight = 200;
        doc.setFillColor(0, 113, 174); // Blue color (RGB values)
        doc.rect(blueBackgroundFooterX, blueBackgroundFooterY, blueBackgroundFooterWidth, blueBackgroundFooterHeight, 'F');

        // Add URL
        const url = 'www.dslogistik.ch';
        const urlX = 40;
        const urlY = doc.internal.pageSize.getHeight() - 20;
        doc.setFontSize(10);
        doc.setTextColor(255, 255, 255);
        doc.text(url, urlX, urlY, { align: 'left' });

        // Add address
        const address = 'Bahnhofstrasse 276, 4563 Gerlafingen, Switzerland';
        const addressX = 40;
        const addressY = doc.internal.pageSize.getHeight() - 10;
        doc.setFontSize(10);
        doc.setTextColor(255, 255, 255);
        doc.text(address, addressX, addressY, { align: 'left' });

        // Add address
        const digIT = 'Powered By';
        const digITX = doc.internal.pageSize.getWidth() - 85;
        const digITY = doc.internal.pageSize.getHeight() - 14;
        doc.setFontSize(10);
        doc.setTextColor(255, 255, 255);
        doc.text(digIT, digITX, digITY, { align: 'right' });


        const iconWidthDigIT = 45; // Adjust the width of the icon as needed
        const iconHeightDigIT = 25; // Adjust the height of the icon as needed
        const iconXDigIT = doc.internal.pageSize.getWidth() - 85; // Adjust the horizontal position of the icon (left)
        const iconYDigIT = doc.internal.pageSize.getHeight() - 33; // Adjust the vertical position of the icon (top)

        doc.addImage(digITLogo, 'SVG', iconXDigIT, iconYDigIT, iconWidthDigIT, iconHeightDigIT);
      };

      // Add the title
      const title = this.$t('Filiales').toUpperCase();
      const titleX = doc.internal.pageSize.getWidth() / 2;
      const titleY = 35; // Adjust the vertical position of the title
      doc.setFontSize(25);
      doc.setTextColor(255, 255, 255); // Black color
      doc.text(title, titleX, titleY, { align: 'center' });

      // Add the author
      const authorX = 40;
      const authorY = 80; // Adjust the vertical position of the author
      const author = `${this.getLoggedInUser.firstName} ${this.getLoggedInUser.lastName}`.toUpperCase();
      doc.setFontSize(12);
      doc.setTextColor(0, 0, 0); // Black color
      doc.text(`${this.$t('Author').toUpperCase()}: ${author}`, authorX, authorY);

      const printingX = doc.internal.pageSize.getWidth() - 130;
      const printingY = 80; // Adjust the vertical position of the printing
      const printing = this.$t('PrintingDate').toUpperCase();
      doc.setFontSize(12);
      doc.setTextColor(0, 0, 0); // Black color
      doc.text(`${printing}`, printingX, printingY);

      const dateX = doc.internal.pageSize.getWidth() - 130;
      const dateY = 95; // Adjust the vertical position of the date
      const date = `${moment().format('MMM D, YYYY')}`;
      doc.setFontSize(13);
      doc.setTextColor(85, 185, 74)// Black color
      doc.text(`${date.toUpperCase()}`, dateX, dateY);

      const timeX = doc.internal.pageSize.getWidth() - 130;
      const timeY = 110; // Adjust the vertical position of the time
      const time = `${this.$t('Time').toUpperCase()}: ${moment().format('HH:mm:ss')}`;
      doc.setFontSize(12);
      doc.setTextColor(0, 0, 0); // Black color
      doc.text(`${time}`, timeX, timeY);


      // Add the table
      const tableOptions = {
        startY: authorY + 50, // Adjust the vertical position of the table
        time: moment().format('DD-MM-YYYY'),
        head: [headers],
        body,
        headStyles: {
          fillColor: [0, 113, 174], // Set the background color for the header
          textColor: [255, 255, 255], // Set the text color for the header
        },
        endY: staticContent.blueBackgroundFooterY - 20,
        afterPageContent: staticContent,
      };
      doc.autoTable(tableOptions);

      return doc;
    },
    generateTableContent2(items) {
      // const headers = ['Store Name', 'GLN', 'Email', 'Phone', 'Street', 'City', 'Country', 'Trucks', 'Manager', 'TeamLeader', 'Co-TeamLeader'];
      const headers = [`${this.$t('FilialeName')}`, `${this.$t('GlobalNumber')}`,
        `${this.$t('EmailAddress')}`, `${this.$t('PhoneNumber')}`,
        `${this.$t('AddNew42')}`, `${this.$t('AddNew43')}`,
        `${this.$t('Trucks')}`, `${this.$t('Manager')}`, `${this.$t('TeamLeader')}`, `${this.$t('Co-TeamLeader')}`];
      const body = items.map((item) => {
        return [
          item.storeName,
          item.gln,
          item.email,
          item.phone,
          item.street,
          item.city,
          item.country,
          item.truckNumbers,
          item.managerName,
          item.teamLeaderName,
          item.coTeamLeaderName,
        ]
      });

      return { headers, body };
    },
    generateExcel(tableContent) {
      const { headers, body } = tableContent;
      const sheetData = [headers, ...body];

      const worksheet = XLSX.utils.aoa_to_sheet(sheetData);
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, 'Sheet1');

      const excelBuffer = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
      const excelData = new Blob([excelBuffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });

      return excelData;
    },
    downloadEXCEL() {
      this.loadStoresByPaginationPDF({
        storeName: this.searchFiliale,
        platform: this.platform,
        pageNumber: this.pageNumber,
        pageSize: this.pageSize,
      })
        .then(() => {
          // const data = response.data;
          // const items = data.items;

          const tableContent = this.generateTableContent(this.getExtendedFilialesPDF.items);

          const totalPages = this.getExtendedFilialesPDF.totalPages;
          const additionalPromises = [];
          for (let pageNumber = 2; pageNumber <= totalPages; pageNumber++) {
            additionalPromises.push(this.downloadPage(pageNumber));
          }

          Promise.all(additionalPromises).then((additionalTableContents) => {
            additionalTableContents.forEach((additionalTableContent) => {
              tableContent.body = tableContent.body.concat(additionalTableContent.body);
            });

            const excelData = this.generateExcel(tableContent);
            FileSaver.saveAs(excelData, 'Filiales.xlsx');
          });
        })
        .catch((error) => {
          console.error('Error downloading the data:', error);
        });
    },

    obj(value) {
      // if (this.getLoggedInUser == 'TeamLeader') {

      // }
      this.storeeeGlnnn = value.gln;
      this.$emit('click', value.gln);
      this.$emit('show-the-component');

      this.loadStoreMainboardOverview({
        storeGLN: value.gln,
        startDate: '2023-01-01',
        endDate: '2023-04-01',
      });
      this.loadUpComingVacations({
        storeGLN: value.gln,
        numberOfDays: 50,
      });
      this.loadRegularEmployeeOverview({
        storeId: value.storeId,
        status: true,
        isRegular: true,
      })
    },





    async fetchCantons() {
      //       // this.changeLoadingtoTrue(false);


      await this.loadCountryStates();
      // await this.freeTeamLeaders();
      // await this.freeCoTeamLeaders();
      // this.changeLoadingtoTrue(true);
    },

    async teamLeader() {
      try {
        await this.freeTeamLeaders().then(() => {
        });
      } catch (e) {
        console.log(e);
      }
    },
    async loadManagers() {
      try {
        await this.loadFreeManagers().then(() => {
        });
      } catch (e) {
        console.log(e);
      }
    },
    async loadCoTeamLeaders() {
      try {
        await this.freeCoTeamLeaders().then(() => {
        });
      } catch (e) {
        console.log(e);
      }
    },
    async fetch() {
      try {
        // this.changeLoadingtoTrue(false);


        await this.loadStoresByPagination({
          pageSize: this.pageSize,
          platform: this.platform,
          pageNumber: this.pageNumber,
        }).then(() => {
          // this.changeLoadingtoTrue(true);
        });

        this.loadFilialePagination({
          status: true,
          pageNumber: 1,
          pageSize: 100,
        });
      } catch (e) {
        console.log(e);
        // this.changeLoadingtoTrue(false);
      }
    },
    edit(item) {
      this.color.mainDressCategoryColorId = item.mainDressCategoryColorId;
      this.color.name = item.colorName;
      this.$bvModal.show('modal-edit-color');
    },
    async editStore(obj) {
      await this.editFilialeById({
        object: obj,
        successCallback: () => {
          this.loadStoresByPagination({
            pageSize: this.pageSize,
            platform: this.platform,
            pageNumber: this.pageNumber,
          });
          this.fetchCantons()
        },
      });
    },
    async addFilialee(obj) {
      await this.addFiliale({
        object: obj,
        successCallback: () => {
          this.loadStoresByPagination({
            pageSize: this.pageSize,
            platform: this.platform,
            pageNumber: this.pageNumber,
          });
        },
      });
    },
    async handleAssignManager(obj) {
      await this.assignManager({
        object: obj,
        successCallback: () => {
          this.loadStoresByPagination({
            pageSize: this.pageSize,
            platform: this.platform,
            pageNumber: this.pageNumber,
          });
          // this.freeTeamLeaders();
        },
      });
    },
    async handleAssignTeamLeader(obj) {
      await this.assignTeamLeader({
        object: obj,
        successCallback: () => {
          this.loadStoresByPagination({
            pageSize: this.pageSize,
            platform: this.platform,
            pageNumber: this.pageNumber,
          });
          // this.freeTeamLeaders();
        },
      });
    },
    async handleAssignCoTeamLeader(obj) {
      await this.assignCoTeamLeader({
        object: obj,
        successCallback: () => {
          this.loadStoresByPagination({
            pageSize: this.pageSize,
            platform: this.platform,
            pageNumber: this.pageNumber,
          });
          // this.freeCoTeamLeaders();
        },
      });
    },
    onArrowDown(ev) {
      ev.preventDefault();
      if (this.arrowCounter < this.getFilterStoreName.length - 1) {
        this.arrowCounter += 1;
        this.fixScrolling();
      }
    },

    onArrowUp(ev) {
      ev.preventDefault();
      if (this.arrowCounter > 0) {
        this.arrowCounter -= 1;
        this.fixScrolling();
      }
    },

    inputChanged(event) {
      if (event.code == 'ArrowUp' || event.code == 'ArrowDown') {
        return;
      }
      // this.getFilteredActiveUsers = [];

      // eslint-disable-next-line no-useless-return
      if (event.code == 'Enter') {
        this.enterPressed = true;
        this.searchByOn(this.getFilterStoreName[this.arrowCounter]);
        this.removeLists();
        this.arrowCounter = 0;
        setTimeout(() => {
          this.enterPressed = false;
        }, 1000);
        // eslint-disable-next-line no-useless-return
        return;
      }
    },
    fixScrolling() {
      const liH = this.$refs.options[this.arrowCounter].clientHeight;
      this.$refs.scrollContainer.scrollTop = liH * this.arrowCounter;
    },
    async searchByOn(value) {
      // console.log('tre', value)
      this.searchFiliale = value;
      this.noSearch = false;
      await this.loadStoresByPagination({
        storeName: value,
        platform: this.platform,
        pageNumber: this.pageNumber,
        pageSize: this.pageSize,
      });
    },
    editFiliale(id) {
      this.getFilialeById(id)
    },
    matProps(color) {
      this.storeId = color;
      this.loadCountryStates()
    },
    removeLists() {
      this.noSearch = false;
      this.resetFilteredFiliale();
    },
  },
};
</script>

<style scoped lang="scss">
.color-listing__wrapper {
  .mats-listing {
    margin-top: 0;
  }
  .table__search-input {
    visibility: hidden;
  }
  input {
    width: 100px;
  }
}

.btn-secondary{
  background: transparent linear-gradient(53deg, #0071AE 0%, #55B94A 100%) 0% 0% no-repeat padding-box;
}

span{
  color: black;
}
p{
  color: black;
}
table td{
  color: black;
}
.button {
  margin-bottom: 15px !important;
  width: 195px;
}
.mat {
  display: flex;
  justify-content: space-between;
  align-content: center;
  &.active {
    background-color: #e8e8e8;
  }
  div {
    display: flex;
    justify-content: space-between;
    align-content: center;
  }
  span {
    margin-left: 10px;
    svg {
      font-size: 15px;
    }
  }
}
.team_table {
  font-size: 12px;
  border-radius: 8px 8px 8px 8px !important;
}

tr:last-child {
  border-bottom: none !important;
}
@media screen and (max-width: 1823px) {
  .color-listing__wrapper2 {
    width: 200px;
    button {
      width: 90%;
    }
    .team_table {
      width: 150px !important;
    }
  }
}
@media screen and (max-width: 1400px) {
  .color-listing__wrapper {
    margin-left: 50px;
    width: 150px !important;
    .team_table {
      width: 150px !important;
    }
  }
  .color-listing__wrapper2 {
    margin-left: 10px;
    width: 200px !important;
    button {
      width: 150px;
      font-size: 13px;
      height: 36px;
    }
    .team_table {
      width: 100% !important;
    }
  }
}
.search1 {
  padding: 0px;
}
.black {
  position: relative;
}
.black input {
  border: none;
  box-shadow: rgb(40 41 61 / 14%) -1px 4px 10px;
  height: 36px;
}
.dropdrop::-webkit-scrollbar {
  display: none;
}
.dropdrop {
  display: inline-block;
  overflow: auto;
  position: absolute;
  background: white;
  width: 227px;
  box-shadow: rgb(40 41 61 / 14%) -1px 4px 10px;
}
.search-item {
  padding: 5px;
  max-width: 500px;
  width: 100%;
  font-weight: 600;
  color: #82868c;
  font-size: 1rem;
  border-bottom: 1px solid #e8e8e8;
}
.search-item:last-child {
  border-bottom: none;
}
.search-item:hover {
  background: #82868c;
  color: white;
}
.search-item hr {
  color: lightgray;
  border-top: none;
  margin: -1.3rem 0 0.5rem 0;
}
.is-active {
  background-color: #dedede;
}
@media screen and (max-width: 896px) {
  .color-listing__wrapper {
    margin-left: 0 !important;
    flex-basis: 49%;
  }
}
.button {
  width: 195px;
}
.addEmployeeButton {
  width: 210px;
}

@media screen and (max-width: 1600px) {
  .scroll {
    overflow-x: scroll;
  }
}

@media screen and (max-width: 1110px) {
  .button {
    margin-right: 10px;
    font-size: 12px;
    height: 36px;
    width: 150px;
  }
}

.dropdrop::-webkit-scrollbar {
  display: none;
}

.dropdrop {
  display: inline-block;
  overflow: auto;
  position: absolute;
  background: white;
  width: 227px;
  box-shadow: rgb(40 41 61 / 14%) -1px 4px 10px;
  z-index: 3;
}

input[name="search-box"] {
  display: block;
  max-width: 500px;
  width: 95%;
  padding: 0.5rem 1rem;
  padding-left: 25px;
}

.black {
  position: relative;
}

.black input {
  border: none;
  box-shadow: rgb(40 41 61 / 14%) -1px 4px 10px;
}

.search-item {
  padding: 5px;
  max-width: 500px;
  width: 100%;
  font-weight: 600;
  color: #82868c;
  font-size: 1rem;
  border-bottom: 1px solid #e8e8e8;
}

.search-item:last-child {
  border-bottom: none;
}

.search-item:hover {
  background: #82868c;
  color: white;
}

.search-item hr {
  color: lightgray;
  border-top: none;
  margin: -1.3rem 0 0.5rem 0;
}

@media screen and (max-width: 763px) {
  .con {
    flex-wrap: wrap;
  }

  .active-inactive-con {
    display: flex;
    align-items: center;
    margin-bottom: 10px;
  }

  .button {
    height: auto;
  }
}

.is-active {
  background-color: #dedede;
}
</style>
